/* eslint-disable import/no-extraneous-dependencies */
import React, { useRef, useState } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import SlickCarouselRootElement from './style';
import CardDetails from '../cardDetails/cardDetails';
import { getCradPreviewLength } from '../../utils/srp.util';
import ListingShimmer from '../../components/srp/Listing/listingShimmer';

const CardCarousel = ({
  dataList, handleViewMore, displayName, type, headline, loading, view, getLink,
  theme,
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const sliderRef = useRef();
  const handleNext = () => {
    if (dataList?.length === 0 || Math.round(activeStep) === dataList?.length - 1) {
      return;
    }
    const slidesToScroll = activeStep + getCradPreviewLength();
    sliderRef.current.slickGoTo(slidesToScroll);
    setActiveStep(slidesToScroll);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      return;
    }
    const slidesToScroll = activeStep - getCradPreviewLength();
    sliderRef.current.slickGoTo(slidesToScroll);
    setActiveStep(slidesToScroll);
  };
  const afterSlideChange = (idx) => {
    setActiveStep(idx);
  };

  return (
    <SlickCarouselRootElement theme={theme}>
      {!!dataList?.length && (
        <Box
          className="prev-button"
          size="small"
          onClick={handleBack}
          disabled={activeStep === 0}
        >
          Prev
        </Box>
      )}
      {!!dataList?.length && (
        <Box
          className="next-button"
          size="small"
          onClick={handleNext}
          disabled={
            dataList?.length === 0
                    || Math.round(activeStep) === dataList?.length - 1
          }
        >
          Next
        </Box>
      )}
      <Slider
        ref={sliderRef}
        dots={false}
        infinite={false}
        arrows={false}
        slidesToShow={getCradPreviewLength() + 0.12}
        slidesToScroll={getCradPreviewLength()}
        afterChange={afterSlideChange}
      >
        {(!!dataList.length) && dataList.map((element) => (
          <CardDetails
            key={element.id}
            link={getLink(element)}
            handleViewMore={() => handleViewMore(element)}
            displayName={element[displayName]}
            headline={element[headline]}
            type={type}
            view={element.title && view}
          />
        ))}
        {(loading) && [...Array(getCradPreviewLength()).keys()].map((idx) => (
          <ListingShimmer key={`shimmer-${idx}`} view={view} />
        ))}
      </Slider>
    </SlickCarouselRootElement>
  );
};

CardCarousel.propTypes = {
  handleViewMore: PropTypes.func,
  dataList: PropTypes.arrayOf(PropTypes.shape({})),
  type: PropTypes.string,
  displayName: PropTypes.string,
  headline: PropTypes.string,
  loading: PropTypes.bool,
  theme: PropTypes.string,
  view: PropTypes.bool,
  getLink: PropTypes.func,
};
CardCarousel.defaultProps = {
  dataList: [],
  handleViewMore: () => {},
  type: '',
  displayName: '',
  headline: '',
  loading: false,
  theme: 'dark',
  view: false,
  getLink: () => {},
};

export default CardCarousel;
